import axios from "axios";
import { deepSanitize } from '../Sanitize';

// const MANAGEMENT_CONSOLE_BASE_URL = "http://10.10.72.16:6700";
// const USER_BASE_URL = "http://10.10.72.16:6701";
// const CMS_BASE_URL = "http://10.10.72.16:6705";

const MANAGEMENT_CONSOLE_BASE_URL = "https://partnerapi.synnex.com.au";
const USER_BASE_URL = "https://partnerapi.synnex.com.au";
const CMS_BASE_URL = "https://partnerapi.synnex.com.au/";

const CLOUD_MANAGER_BASE_URL = "https://cloudapi.synnex.com.au/brokerage/";

const api = axios.create({
  baseURL: MANAGEMENT_CONSOLE_BASE_URL,
});

const userApi = axios.create({
  baseURL: USER_BASE_URL,
});

// userApi.interceptors

// Orchid Core CMS Base URL
const cmsApi = axios.create({
  baseURL: CMS_BASE_URL,
});

// Cloud Manager API — used for secure credential delivery (e.g. Admin Portal credentials page)
const cloudManagerApi = axios.create({
  baseURL: CLOUD_MANAGER_BASE_URL,
});

// XSS Defense: Request interceptor — sanitize all string values before sending
// Covers:
//   config.data   — POST/PUT/PATCH request body (JSON object)
//   config.params — GET query params passed as object { params: { search: '...' } }
//   config.url    — GET query strings built via template literals (e.g. ?searchText=${value})
//                   URL query param values are decoded, sanitized, then re-encoded.
// Strips complete HTML tags and javascript: URI scheme from all string values.
// Numbers, booleans, null, arrays, nested objects pass through unchanged.
// FormData payloads are skipped (browser handles multipart encoding).
const sanitizeUrlParams = (url) => {
  if (!url || !url.includes('?')) return url;
  const [base, query] = url.split('?');
  const sanitizedQuery = query
    .split('&')
    .map(pair => {
      const eqIdx = pair.indexOf('=');
      if (eqIdx === -1) return pair;
      const key = pair.slice(0, eqIdx);
      const rawValue = pair.slice(eqIdx + 1);
      try {
        const decoded = decodeURIComponent(rawValue);
        const sanitized = decoded
          .replace(/<[^>]*>/gi, '')     // strip complete HTML tags
          .replace(/javascript:/gi, ''); // strip javascript: URI scheme
        return `${key}=${encodeURIComponent(sanitized)}`;
      } catch {
        return pair; // if decoding fails, leave unchanged
      }
    })
    .join('&');
  return `${base}?${sanitizedQuery}`;
};

const addSanitizationInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.request.use((config) => {
    // Sanitize request body (POST/PUT/PATCH)
    if (config.data && typeof config.data === 'object' && !(config.data instanceof FormData)) {
      config.data = deepSanitize(config.data);
    }
    // Sanitize query params passed as object
    if (config.params && typeof config.params === 'object') {
      config.params = deepSanitize(config.params);
    }
    // Sanitize query params interpolated directly into the URL string
    if (config.url && typeof config.url === 'string') {
      config.url = sanitizeUrlParams(config.url);
    }
    return config;
  }, (error) => Promise.reject(error));
};

// Apply sanitization interceptors to api and userApi (not cmsApi — CMS sends graphql strings)
addSanitizationInterceptor(api);
addSanitizationInterceptor(userApi);

// Function to add 503 error handling to any API instance
const setup503Handler = (axiosInstance, setMaintenanceActive) => {
  axiosInstance.interceptors.response.use(
    response => response,
    // response => {
    //   if (response.status === 200) {
    //     console.log("TEST MODE: Triggering maintenance mode on 200 response");
    //     if (setMaintenanceActive && typeof setMaintenanceActive === 'function') {
    //       console.log("success code handled");
    //       setMaintenanceActive(true);
    //     }
    //   }
    //   return response;
    // },
    error => {
      if (error?.status == 503 || error?.response?.status == 503) {
        // Call the setMaintenanceActive function from context if it exists
       console.log("TEST MODE: Triggering maintenance mode on 400 error code"); 
        if (setMaintenanceActive && typeof setMaintenanceActive === 'function') {
          setMaintenanceActive(true);
          return Promise.resolve({
            data: null,
            status: 503,
            handled: true,
            maintenance: true
          });
        }
      }
      return Promise.reject(error);
    }
  );
};

// This function will be called when the MaintenanceContext is initialized
export const setupMaintenanceHandling = (setMaintenanceActive) => {
  // console.log(setMaintenanceActive, "setMaintenanceActive");
  // Set up handlers for all API instances
  setup503Handler(api, setMaintenanceActive);
  setup503Handler(userApi, setMaintenanceActive);
  // setup503Handler(cmsApi, setMaintenanceActive);
};


export { api, userApi, cmsApi, cloudManagerApi };
